// @flow
import React from 'react'

type Props = {
  color: string
}

const Hamburger = (props: Props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
    <path d='M0 0h24v24H0z' fill='none' />
    <path d='M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' fill={props.color} />
  </svg>
)

export default Hamburger
